import { FlashMessageLoadable } from '#/components/FlashMessage/FlashMessageLoadable';
import {
  removeFlashMessage,
  useFlashMessages,
} from '#/zustand-stores/flashMessagesStore';
import {
  useHorizonFlashMessage,
  useHorizonFlashMessageActions,
} from '#/zustand-stores/horizonFlashMessageStore';

export function FlashMessageContainer() {
  const { horizonFlashMessage } = useHorizonFlashMessage();
  const { clearHorizonFlashMessage } = useHorizonFlashMessageActions();

  const { flashMessages } = useFlashMessages();

  if (flashMessages.length === 0 && !horizonFlashMessage) return null;

  return (
    <div id="flash-message-container">
      {horizonFlashMessage && (
        <FlashMessageLoadable
          flashMessage={horizonFlashMessage}
          removeMessage={() => clearHorizonFlashMessage()}
        />
      )}

      {flashMessages.map((flashMessage) => (
        <FlashMessageLoadable
          key={flashMessage.id}
          flashMessage={flashMessage}
          removeMessage={() => removeFlashMessage(flashMessage.id)}
        />
      ))}
    </div>
  );
}
